import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";

type CollapsableCardProps = {
  cardTitle: string;
  cardSubtitle?: string;
  customStyle?: string | Record<string, string | number>;
  expanded?: boolean;
  stepLabel?: string;
  status?: StepStatus;
}

type StepStatus = "default" | "error" | "success" | "warning";


export default /*#__PURE__*/_defineComponent({
  __name: 'CollapsableCardWithHeader',
  props: {
    cardTitle: { default: '' },
    cardSubtitle: { default: '' },
    customStyle: { default: '' },
    expanded: { type: Boolean, default: false },
    stepLabel: { default: '' },
    status: { default: 'default' }
  },
  setup(__props: any) {

const props = __props as { cardTitle: string, cardSubtitle: string, customStyle: string | Record<string, string | number>, expanded: boolean, stepLabel: string, status: StepStatus };



const badgeClass = computed(() => {
  return {
    "step-label": true,
    "step-label-error": props.status === "error",
    "step-label-warning": props.status === "warning"
  };
});

const isExpanded = ref(props.expanded);

const computedStyle = computed(() => {
  if (typeof props.customStyle === "string") {
    return props.customStyle;
  }
  return { ...props.customStyle };
});

watch(
  () => props.expanded,
  (val) => {
    isExpanded.value = val;
  }
);

function expandAccordion() {
  isExpanded.value = !isExpanded.value;
}

function beforeEnter(el: Element) {
  const element = el as HTMLElement;
  element.style.height = "0";
  element.style.opacity = "0";
  element.style.overflow = "hidden";
}

function enter(el: Element) {
  const element = el as HTMLElement;
  element.style.transition = "height 0.28s ease, opacity 0.2s ease";
  element.style.height = `${element.scrollHeight}px`;
  element.style.opacity = "1";
}

function afterEnter(el: Element) {
  const element = el as HTMLElement;
  element.style.height = "auto";
  element.style.overflow = "visible";
  element.style.transition = "";
}

function beforeLeave(el: Element) {
  const element = el as HTMLElement;
  element.style.height = `${element.scrollHeight}px`;
  element.style.opacity = "1";
  element.style.overflow = "hidden";
}

function leave(el: Element) {
  const element = el as HTMLElement;
  void element.offsetHeight;
  element.style.transition = "height 0.24s ease, opacity 0.15s ease";
  element.style.height = "0";
  element.style.opacity = "0";
}

function afterLeave(el: Element) {
  const element = el as HTMLElement;
  element.style.transition = "";
}

return { __sfc: true,props, badgeClass, isExpanded, computedStyle, expandAccordion, beforeEnter, enter, afterEnter, beforeLeave, leave, afterLeave }
}

})